import styled from 'styled-components';

const ModalLayout = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: auto;
  height: auto;
  position: absolute;
  z-index: 1;
  overflow: hidden;
`;
export default ModalLayout;
